import { Modal } from '@smartgift/frontend-toolkit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ACCEPTED_IMAGES } from '@hero/constants';
import { UploadInput } from '@hero/molecules';
import { useUploadAsset } from '@hero/services/merchant-service/hooks';

import * as S from './style';

function UploadImageModal({
  uploadAction,
  isOpen,
  setIsOpen,
  maxFiles = 1,
  disabled = false,
  children,
  title = 'Upload your image',
  useCustomMutation
}) {
  const { t } = useTranslation();
  const useUpload = useCustomMutation || useUploadAsset;
  const { mutateAsync: uploadAsset, reset, isLoading, isSuccess, error, status } = useUpload();

  const [modalProps] = useState({
    primaryButtonProps: {
      onClick: () => {
        setIsOpen(false);
      }
    }
  });

  const closeModalHandler = () => {
    setIsOpen(false);
  };

  const uploadHandle = async file => {
    if (Array.isArray(file)) {
      file.forEach(async f => {
        const formData = new FormData();
        formData.set('file', f);
        const response = await uploadAsset(formData);
        uploadAction(response);
      });
    } else {
      const formData = new FormData();
      formData.set('file', file);
      const response = await uploadAsset(formData);
      uploadAction(response);
    }
  };

  const handleFile = async file => {
    uploadHandle(file);
  };

  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        closeModalHandler();
        reset();
      }, 200);
    }
  }, [isSuccess]);

  return (
    <S.UploadImageModal>
      {children}
      <Modal isOpen={isOpen} onRequestClose={closeModalHandler} title={title} {...modalProps}>
        <UploadInput
          disabled={disabled}
          handleFile={handleFile}
          fileInformation={ACCEPTED_IMAGES}
          maxFiles={maxFiles}
          status={status}
          isLoading={isLoading}
          apiError={error}
          instructions={[t('recommendedImgSize', { sizes: '400 x 400' })]}
        />
      </Modal>
    </S.UploadImageModal>
  );
}

export { UploadImageModal };
